import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatus } from '@common/enums';

@Pipe({
  name: 'statusIcon',
  pure: true
})
export class TaskStatusIconPipe implements PipeTransform {
  private readonly map = new Map<TaskStatus, string>([
    [TaskStatus.Pending, 'fa fa-clock-o'],
    [TaskStatus.Running, 'fa fa-spinner rotating'],
    [TaskStatus.Finished, 'fa fa-check-circle'],
    [TaskStatus.Failed, 'fa fa-exclamation-circle'],
    [TaskStatus.Paused, 'fa fa-pause-circle'],
    [TaskStatus.LimitExceeded, 'fa fa-exclamation-triangle'],
    [TaskStatus.Cancelled, 'fa fa-times-circle']
  ]);

  transform(status: TaskStatus): any {
    const classes: string[] = [];

    if (status) {
      classes.push(this.map.get(status));
    }

    return classes.join(' ');
  }
}
